import React, { FC } from "react";
import { Alert as MuiAlert, AlertProps } from "@mui/material";

const Alert: FC<AlertProps> = (props) => <MuiAlert {...props} />;

export default Alert;
